
import { defineComponent, inject, onMounted, reactive } from 'vue'

import InvoiceDestination from '@/modules/Invoice/components/InvoiceDestination/index.vue'
import ltlAPI from '@/new-services/ltl.service'
import UploadedFile from '@/common/components/UploadedFile/index.vue'
import { LtlPackageFile, UploadedFileT } from '@/core/types/LTL.types'
import SLoader from '@/common/components/SLoader/index.vue'

export default defineComponent({
    components: {
        'invoice-destination': InvoiceDestination,
        UploadedFile,
        SLoader,
    },
    setup() {
        const invoiceState: any = inject('invoiceState')

        const state = reactive({
            is_loading: false,
            softPackage: [] as UploadedFileT[],
            grid: [] as UploadedFileT[],
        })

        const fillSoftPackage = (response: any) => {
            if (response.data.data) {
                if (response.data.data.softPackage) {
                    const { softPackage } = response.data.data
                    if (softPackage.length) {
                        state.softPackage = softPackage.map((file: LtlPackageFile) => {
                            return {
                                id: file.id,
                                original_name: file.originalName,
                                path: file.url,
                            }
                        })
                    }
                }
            }
        }

        const fillGrid = (response: any) => {
            if (response.data.data) {
                if (response.data.data.grid) {
                    const { grid } = response.data.data
                    if (grid.length) {
                        state.grid = grid.map((file: LtlPackageFile) => {
                            return {
                                id: file.id,
                                original_name: file.originalName,
                                path: file.url,
                            }
                        })
                    }
                }
            }
        }

        const loadFiles = async () => {
            const softPackage = invoiceState.data.additional_services_values.find(
                (service: any) => service.type_id === 4
            )
            const grid = invoiceState.data.additional_services_values.find(
                (service: any) => service.type_id === 6
            )

            if (!invoiceState.data.invoice_number || (!grid && !softPackage)) return

            try {
                state.is_loading = true

                const response: any = await ltlAPI.getLtlPackageFiles(
                    invoiceState.data.invoice_number
                )
                fillSoftPackage(response)
                fillGrid(response)
            } catch (error) {
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        onMounted(loadFiles)

        return { state, invoiceState }
    },
})
